module.exports = __webpack_public_path__ + "img/anli1@2X.ff0b9684.png";